"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.version = "4.0.32";



//////////////////
// WEBPACK FOOTER
// ./packages/truffle-interface-adapter/~/ethers/_version.js
// module id = 2073
// module chunks = 0 1 3